import React, { useEffect, useState } from "react"
import MobileMenu from '../MobileMenu'
import {TopNavbarContainer} from './style'
import {Col, Row} from  'antd'
import {MenuOutlined} from '@ant-design/icons'

function TopNavbar() {
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false)
  const [menuContent, setMenuContent] = useState()
  useEffect(()=>{
    const example = [
      {
        title: "Dia a dia da ferramenta",
        key: "sub1",
        subItems:[
          {
            title: "Como ligar",
            key: "1",
            link: "/como-ligar"
          },
          {
              title: "Como utilizar",
              key: "2",
              link: "/como-utilizar"
            },
        ],
      },
      {
          title: "Procedimentos para correções",
          key: "sub2",
          subItems:[
            {
              title: "Tela branca",
              key: "3",
              link: "/tela-branca"
            },
            {
                title: "Melhores práticas de uso",
                key: "4",
                link: "/melhores-praticas"
              },
          ],
        },
        {
          title: "Dúvidas, problemas e sugestões",
          key: "5",
          mailto: "mailto:suportesmartstore@dex.co"
        }
    ]
    setMenuContent(example)
  }, [])
  
  return (
    <TopNavbarContainer>
      <Row className='topnavbar-row' justify='space-between'>
        <Col>
        <MenuOutlined className='topnavbar-hamburger' onClick={()=>setMobileMenuVisible(true)} />
        </Col>
        <Col>
        <img height='32px' src='/simular_logo.svg' alt="logo" />
        </Col>
        <Col>
        {/* Search col */}
        </Col>
      </Row>
      <MobileMenu visible={mobileMenuVisible} setVisible={setMobileMenuVisible} content={menuContent} menuClassName='menu-mobile'/>
    </TopNavbarContainer>

    )
}

export default TopNavbar
